import { render } from "./HighlightItem.vue?vue&type=template&id=2b687018"
import script from "./HighlightItem.vue?vue&type=script&lang=js"
export * from "./HighlightItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__